import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { ROLE_RANK, UserRole } from '../models/user.model';
import { AuthService } from '../services/auth.service';

/**
 * The Pass role ladder from /auth/me. Both guards wait for bootstrap first and never clear the session: a person
 * whose account did not load is sent to /login, where the reason is shown.
 */
export function roleGuard(minRole: UserRole): CanActivateFn {
  return async (_route, state: RouterStateSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    await authService.ready();
    const user = authService.currentUser();
    if (!user || !user.role) {
      return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }
    if (ROLE_RANK[user.role] < ROLE_RANK[minRole]) {
      return router.createUrlTree(['/profiles']);
    }
    return true;
  };
}

export const superadminGuard: CanActivateFn = async (_route, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.ready();
  const user = authService.currentUser();
  if (!user || !user.role) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }
  if (user.role !== 'superadmin' || user.org_id !== 1) {
    return router.createUrlTree(['/profiles']);
  }
  return true;
};
